import Config from '../config/Config';

export const tagEvent = (tagdata) => {
    
}